import React from "react";
import MessageBubble from "./MessageBubble";

export default function MessageThread({
  messages,
  messageListRef,
  onScroll,
  isGroupChat,
  currentUserId,
  formatMessageTime,
  isProbablyGifUrl,
  showTyping,
  resolveSenderLabel,
  bubbleToneClass,
}) {
  return (
    <div
      ref={messageListRef}
      onScroll={onScroll}
      className="flex-1 min-h-0 overflow-y-auto fc-scroll px-7 py-6 space-y-4"
    >
      {messages.map((msg, idx) => {
        const isOwn = Number(msg?.sender_id) === Number(currentUserId);
        const baseName = msg?.sender_username || "Unknown";
        const senderLabel =
          typeof resolveSenderLabel === "function"
            ? resolveSenderLabel(msg?.sender_id, baseName)
            : baseName;
        return (
          <MessageBubble
            key={msg?.id || idx}
            message={msg}
            isOwn={isOwn}
            isGroupChat={isGroupChat}
            senderName={senderLabel}
            senderAvatar={msg?.sender_avatar}
            timestamp={formatMessageTime(msg?.created_at)}
            showGif={isProbablyGifUrl(msg?.message || "")}
            bubbleSurfaceClass={
              typeof bubbleToneClass === "function" ? bubbleToneClass(isOwn) : undefined
            }
          />
        );
      })}

      {showTyping && (
        <div className="flex justify-start">
          <div className="max-w-[78%]">
            <div className="rounded-[18px] border border-white/12 bg-white/[0.06] px-4 py-2.5">
              <div className="flex gap-1.5 items-center">
                <span className="h-1.5 w-1.5 rounded-full bg-white/70 animate-bounce" />
                <span
                  className="h-1.5 w-1.5 rounded-full bg-white/70 animate-bounce"
                  style={{ animationDelay: "0.12s" }}
                />
                <span
                  className="h-1.5 w-1.5 rounded-full bg-white/70 animate-bounce"
                  style={{ animationDelay: "0.24s" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
